import {registerTemplateGraphNode} from "#template/template-node/register"
import {
    meshGeometryAttributeSetLike,
    meshGeometryAttributeSetLikeMarker,
    curveGeometryAttributeSetLike,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike, meshGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode, MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeSetLikeNode, MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {ProductOperatorPairParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"
import {
    GeometryProductOperatorPairNode,
    productOperatorPairParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-pair-node"

export type MeshGeometryProductOperatorCurveGeometryMeshGeometryInputParameters = ProductOperatorPairParameters<
    CurveGeometryAttributeLikeNode,
    CurveGeometryAttributeSetLikeNode,
    MeshGeometryAttributeLikeNode,
    MeshGeometryAttributeSetLikeNode
>

const definition: TemplateNodeDefinition<MeshGeometryProductOperatorCurveGeometryMeshGeometryInputParameters> = {
    nodeClass: "MeshGeometryProductOperatorCurveGeometryMeshGeometryInput",
    validation: {
        parameters: productOperatorPairParametersSchema(
            curveGeometryAttributeLike,
            curveGeometryAttributeSetLike,
            meshGeometryAttributeLike,
            meshGeometryAttributeSetLike,
        ),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryProductOperatorCurveGeometryMeshGeometryInput
    extends GeometryProductOperatorPairNode<
        2,
        CurveGeometryAttributeLikeNode,
        CurveGeometryAttributeSetLikeNode,
        MeshGeometryAttributeLikeNode,
        MeshGeometryAttributeSetLikeNode
    >
    implements MeshGeometryAttributeSetLikeNode
{
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    protected override get outputIndexingDim(): 2 {
        return 2
    }
}
